// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/hyperventilation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/hyperventilation/hyperventilation.js';

mount([g0]);
